import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import { MouseEvent } from '@agm/core';
import { ValidationService, ValidationType } from '../../services/validation.service';

declare const navigator: any;
@Component({
  selector: 'app-location',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility">
  <div class="hazard-description location-form-field">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <div class="relvte">
    <img class="bg-image" [ngClass]="{'pointer-events' : !field.style.editability}" src="assets/rff-images/map-icon.svg" [ngbPopover]="popContent">
    </div>
    <input class="form-control focus-color" *ngIf="field.value" [ngClass]="{'pointer-events' : !field.style.editability}" value="{{field.value.lat | number : '1.0-5'}} , {{field.value.long | number :'1.0-5'}}" placeholder="Location" readonly>
    <input class="form-control focus-color" *ngIf="!field.value" [ngClass]="{'pointer-events' : !field.style.editability}" value="" placeholder="Location" (click)="askUserForConsent()" readonly>
    <ng-template #popContent>
      <agm-map [latitude]="lat" [longitude]="long" [zoom]="zoom" [disableDefaultUI]="false" [zoomControl]="false">
        <agm-marker *ngFor="let m of markers; let i = index" [latitude]="m.lat" [longitude]="m.long" [label]="m.label" [markerDraggable]="m.draggable" (dragEnd)="markerDragEnd(m, $event)"></agm-marker>
      </agm-map>
    </ng-template>
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
`,
  styles: [`.location-form-field{position:relative;float:left;width:100%}.location-form-field p{margin:24px 0 10px;padding:0;}.relvte{position:relative;float:left;width:100%}.bg-image{position: absolute;left: 224px;top:7px}`]
})
export class LocationComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  zoom: number = 8;
  lat: number;
  long: number;
  
  markerDragEnd(m: marker, $event: MouseEvent) {
   this.field.value = {
     lat : $event.coords.lat,
     long : $event.coords.lng
   }
   this.group.value[this.field.id] = this.field.value;
   const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  };
  markers: marker[] = [];
  ngOnInit() {
    this.findMe();
    // Check for Geolocation API permissions
    navigator.permissions.query({ name: 'geolocation' })
      .then((permissionStatus) => {
        console.log('geolocation permission state is ', permissionStatus.state);

        permissionStatus.onchange = (event) => {
          const element: any = event.currentTarget || event.target || event.srcElement;
          if (element.state === "granted" && this.field.validation.isRequired) {
            this.findMe();
          }
        };
      });
  };
  findMe() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.showPosition(position);
      }, (error) => {
        if(error.message === "User denied Geolocation") {
          if(this.field.validation.isRequired) {
            this.field.errorMessage = "Please grant location permission."
          }
        }
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }
  askUserForConsent() {
    this.findMe();
  }
  constructor(
    private _validationService: ValidationService,
    private _cdr: ChangeDetectorRef
  ) { }
  showPosition(position) {
    this.lat = position.coords.latitude;
    this.long = position.coords.longitude;
    this.markers = [{
      lat: this.lat,
      long: this.long,
      draggable: true
    }]
    this.field.value = {
      lat : this.lat,
      long : this.long
    };
    if(this.field.value) {
      this.field.errorMessage = "";
    } 
    this._cdr.detectChanges();
  }
}
interface marker {
  lat: number;
  long: number;
  label?: string;
  draggable: boolean;
};



// WEBPACK FOOTER //
// ./src/app/rFF/fields/location/location.component.ts